import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { showPopover } from '../../providers/popoverProvider.jsx';
import ModalBox from './ModalBox.jsx';

const Modal = class Modal extends React.Component {
  static displayName = 'Modal';
  constructor(props) {
    super(props);
    this.state = {
      popover: null
    };

    this.type = this.props.config.typeModal || 'modal';
    this.providerToggleModal = this.props.config.toggleModal;

    !this.props.config.refreshOnMount && this.refreshModal();
  }

  refreshModal = (extraArguments) => {
    this.toggleModal = this.toggleModal.bind(this);
    this.parsedPopover = is(Function, this.props.config.popover)
      ? this.props.config.popover(this.toggleModal, extraArguments)
      : this.props.config.popover;

    //TODO: xapu per prevenir tancar modal onclick. by a ladin
    this.modal = (
      <ModalBox 
        close={this.eventToggleModal(false)} 
        toggle={!this.props.config.preventToggleModal ? this.eventToggleModal(false) : () => { }}
        defaultStyle={this.props.config.defaultStyle}
        type={this.type}
        filterModal={this.props.config.filterModal}
        contentStyle={this.props.config.contentStyle}
        modalStyle={this.props.config.modalStyle}
        closeButtonStyle={this.props.closeButtonStyle}
        >{this.parsedPopover}</ModalBox>
    );
  };

  eventToggleModal = (show) => (e) => {
    if (e) {
      e.preventDefault();
      if (this.props.config.disableCloseOnClick) {
        return;
      }

    }
    this.toggleModal(show);
  }
  toggleModal = (show, extraArguments) => {
    if (show) {
      this.closeFunction = e => {
        if (e.keyCode === 27) {
          this.toggleModal(false);
        }
      };
      window.addEventListener('keyup', this.closeFunction);
      if (this.props.config.refreshOnMount) {
        this.refreshModal(extraArguments);
      }
    } else {
      window.removeEventListener('keyup', this.closeFunction);
      if(this.props.config.closeCallback){
        this.props.config.closeCallback();
      }
    }

    this.providerToggleModal(show, this.type, this.modal, null, 0);
    document.body.style.overflow = show ? 'hidden' : 'auto';
  };

  componentWillUnmount = () => {
    this.toggleModal(false);
  };

  componentDidMount = () => {
    this.props.config.instantToggle && this.toggleModal(true);
  };

  render() {
    const { children } = this.props;
    return (
      <React.Fragment>
        {children &&
        (typeof children === 'function' ? children(this.toggleModal) :
          React.cloneElement(children, {
            onClick: e => {
              this.toggleModal(true);
              children.props.onClick && children.props.onClick(e);
            }
          }))}
      </React.Fragment>
    );
  }
};

export default compose(
  showPopover,
  PropertyManager([
    'alt',
    'button',
    'typeModal',
    'toggleModal',
    'hideModal',
    'popoverGetter',
    'popover',
    'filterModal',
    'modalStyle',
    'contentStyle',
    'onlyContent',
    'closeButtonStyle',
    'instantToggle',
    'disableCloseOnClick',
    'preventToggleModal',
    'closeCallback',
    'refreshOnMount',
    'children'
  ]),
)(Modal);
